<template>
  <div class="admin-ad">
    <v-card class="mt-4">
      <v-card-title class="d-flex align-center mb-7">
        <h3>لیست شرکت ها</h3>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="جستجو بر اساس نام شرکت، مدیر و محصولات"
          class="flex-fill mx-7 mt-0 pt-0"
          single-line
          hide-details
        ></v-text-field>
        <v-btn depressed color="secondary" router :to="{ name: 'AdminAddAd' }">
          ایجاد تبلیغ جدید
        </v-btn>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="ads"
        :footer-props="{ 'items-per-page-options': [10, 50, 100] }"
        :search="search"
        disable-sort
        fixed-header
        item-key="_id"
      >
        <template v-slot:[`item.name`]="{ item }">
          <div class="d-flex align-center">
            <v-img :src="item.imgUrl" />
            <div class="text-no-wrap">{{ item.name }}</div>
          </div>
        </template>

        <template v-slot:[`item.createDateTime`]="{ item }">
          <persian-date :date="item.createDateTime" />
        </template>

        <template v-slot:[`item.active`]="{ item }">
          <span v-if="item.active">فعال</span>
          <span v-else>غیرفعال</span>
        </template>

        <template v-slot:[`item._id`]="{ item }">
          <div class="d-flex align-center justify-center">
            <v-btn
              depressed
              small
              fab
              outlined
              color="grey darken-3"
              class="mx-2"
              :href="item.url"
              target="_blank"
            >
              <v-icon>mdi-web</v-icon>
            </v-btn>

            <v-btn
              v-if="item.active"
              depressed
              small
              fab
              outlined
              color="primary"
              class="mx-2"
              @click="handleDisableAd(item._id)"
            >
              <v-icon class="text-body-2">mdi-close</v-icon>
            </v-btn>
            <v-btn
              v-else
              depressed
              small
              fab
              outlined
              color="success"
              class="mx-2"
              @click="handleEnableAd(item._id)"
            >
              <v-icon class="text-body-2">mdi-check</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AdminAd",
  data() {
    return {
      search: "",
      ads: [],
      headers: [
        {
          text: "تبلیغ",
          value: "name",
          align: "center"
        },
        {
          text: "زمان ایجاد تبلیغ",
          value: "createDateTime",
          align: "center"
        },
        {
          text: "وضعیت ؟",
          value: "active",
          align: "center"
        },
        {
          text: "اقدامات",
          value: "_id",
          align: "center",
          width: 400
        }
      ]
    };
  },
  created() {
    this.handleGetAds();
  },
  methods: {
    handleGetAds() {
      this.$api
        .get("advertise/all")
        .then((res) => {
          this.ads = res.data.advertise;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleDisableAd(id) {
      this.$api
        .post("advertise/disable", {
          advertise: id
        })
        .then(() => {
          this.handleGetAds();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    handleEnableAd(id) {
      this.$api
        .post("advertise/enable", {
          advertise: id
        })
        .then(() => {
          this.handleGetAds();
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
};
</script>
